export default __webpack_public_path__ + "static/media/unreadable_ecg.284626ed.svg";